import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { getPetitionReadyToSharePosts, type ReadyToSharePosts } from 'src/app/shared/api/readyToShare';

const QUERY_KEY = 'ready-to-share';
// const CACHE_TIME_MS = 5 * 60 * 1000;
const CACHE_TIME_MS = Infinity;
export const REFETCH_INTERVAL_MS = 5000;
export const MAX_REFETCH_COUNT = 5;

function hasData(posts: ReadyToSharePosts) {
	return posts.totalCount > 0 && posts.items[0].message;
}

export function useFetchReadyToSharePost({ slug, shouldExecute }: { slug: string; shouldExecute: boolean }) {
	const utilityContext = useUtilityContext();

	return useQuery<ReadyToSharePosts>({
		queryKey: [QUERY_KEY, slug],
		queryFn: async () => {
			const posts = await getPetitionReadyToSharePosts(slug, utilityContext);
			if (!hasData(posts)) {
				throw new Error(`PREVIEW_LINK_NOT_FOUND: No Facebook preview link found for petition ${slug}`);
			}
			return posts;
		},
		staleTime: CACHE_TIME_MS,
		retry: MAX_REFETCH_COUNT,
		retryDelay: REFETCH_INTERVAL_MS,
		refetchOnWindowFocus: false, // Only refetch data if the tab/window is on focus
		enabled: shouldExecute, // Only execute if shouldExecute is true
	});
}
